import {combineReducers} from "redux";
import ProductReducer from "../reducer/productReducer";
import userReducer from "../reducer/userReducer";

const rootReducer = combineReducers({
    user: userReducer,
    product: ProductReducer
})

export default rootReducer;
